import moment from "moment-timezone";

import {formatDateAndTimeRange} from "./DateTimeRangeHelper";
import {
    calculateNetAmendmentDurationInMinutes,
    calculateTotalShiftDurationIncludingCheckInTimeInMinutes
} from "./ShiftHelper";

export default class ShiftAdminUtils {
    static mapShiftServiceKeycodes(shift) {
        return (shift?.bookableServiceTypes || [])
            .map((service) => service?.serviceType.keycode)
            .filter(Boolean);
    }

    static buildShiftTimeRanges(shifts, timezone) {
        return shifts
            .map((shift) => {
                const shiftStartTime = shift.performingFrom;
                const shiftEndTime = shift.to;

                return {
                    shiftStartTime,
                    label: formatDateAndTimeRange(shiftStartTime, shiftEndTime, timezone).time,
                };
            })
            .sort((left, right) => moment(left.shiftStartTime).valueOf() - moment(right.shiftStartTime).valueOf())
            .map((shiftTimeRange) => shiftTimeRange.label);
    }

    static buildAddPerformerMenuOptions(performers, filteredDayRows) {
        const visiblePerformerIds = new Set(filteredDayRows.map((row) => row.performerId));

        return performers
            .filter((performer) => !visiblePerformerIds.has(performer.id))
            .map((performer) => ({
                id: performer.id,
                fullName: `${performer.givenName} ${performer?.familyName}`,
            }))
            .sort((left, right) => left.fullName.localeCompare(right.fullName));
    }

    static doesRowMatchServiceFilter(row, selectedServiceFilters) {
        const rowServices = row?.services || [];

        return selectedServiceFilters.some((serviceFilter) => rowServices.includes(serviceFilter));
    }

    static buildServiceFilteredRowMetrics(row, selectedServiceFilters, timezone) {
        const filteredShifts = (row?.shifts || []).filter((shift) => {
            const shiftServiceKeycodes = ShiftAdminUtils.mapShiftServiceKeycodes(shift);

            return selectedServiceFilters.some((serviceFilter) => shiftServiceKeycodes.includes(serviceFilter));
        });

        const filteredShiftIds = new Set(filteredShifts.map((shift) => shift.id));
        const filteredAmendments = (row?.amendments || []).filter((amendment) => filteredShiftIds.has(amendment?.shift?.id));

        const filteredShiftMinutes = calculateTotalShiftDurationIncludingCheckInTimeInMinutes(filteredShifts);
        const filteredAmendmentMinutes = calculateNetAmendmentDurationInMinutes(filteredAmendments);
        const filteredServiceKeycodes = filteredShifts.flatMap((shift) => ShiftAdminUtils.mapShiftServiceKeycodes(shift));

        return {
            shifts: filteredShifts,
            services: [...new Set(filteredServiceKeycodes)],
            amendments: filteredAmendments,
            totalShiftCount: filteredShifts.length,
            amendmentCount: filteredAmendments.length,
            shiftTimeRanges: ShiftAdminUtils.buildShiftTimeRanges(filteredShifts, timezone),
            totalMinutesIncludingAmendments: filteredShiftMinutes + filteredAmendmentMinutes
        };
    }
}
